// import { Component, OnInit } from '@angular/core';
// import { inject } from '@angular/core/testing';
import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from "@angular/material";
import { ServerService } from 'src/app/services/server.service';
import { HttpClient } from '@angular/common/http';
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';


@Component({
  selector: 'app-client-lead-webhook-edit-modal',
  templateUrl: './client-lead-webhook-edit-modal.component.html',
  styleUrls: ['./client-lead-webhook-edit-modal.component.scss']
})
export class ClientLeadWebhookEditModalComponent implements OnInit {
  webhookInfo:any
  showComponentLoader = false;
  remarks = ''
  token = localStorage.getItem('token')
  constructor(
    private dialogRef: MatDialogRef<ClientLeadWebhookEditModalComponent>,
       private _serverService:ServerService,
       private http:HttpClient,
       private dialog:MatDialog,
       private clipBoardMessageService:messageService,
      //  private changeDetectorRef:ChangeDetectorRef,
       @Inject(MAT_DIALOG_DATA) public data
  ) { 

    this.webhookInfo = this.data;
    // console.log(this.webhookInfo)
    if(this.webhookInfo.remark){
        this.remarks = this.webhookInfo.remark;
    }
  }

  ngOnInit() {
  }
close(){
  this.dialogRef.close()
}
save(){
  let body = {
    "remark":this.remarks,
    "project_id":this.webhookInfo.project_id
  }
  this._serverService.updateWebhook(this.webhookInfo.id,body,this.token).subscribe((data)=>{
    // this.clipBoardMessageService.showMessgeInText('Success','Remark Updated in Webhook')
    this.clipBoardMessageService.showMessgeInText("Remark Updated in Webhook", "success-snackbar")
    this.dialogRef.close(data)
  })
}
}
